// eslint-disable-next-line max-len
// NOTE: this is based on https://github.com/pansa-dev/ngx-cesium/blob/HEAD/projects/@pansa/ngx-cesium/src/lib/@pansa/ngx-cesium-widgets/services/entity-editors/polygons-editor/polygons-manager.service.ts#L7-L41

import { inject, Injectable } from "@angular/core";
import { Cartesian3 } from "cesium";
import { CesiumMapService } from "../../..";
import { EditablePrism } from "../../../models/prism/editable-prism";
import { PrismEditOptions } from "../../../models/prism/prism-edit-options";

@Injectable()
export class PrismsManagerService {
    private readonly prisms: Map<string, EditablePrism> = new Map<string, EditablePrism>();
    private cesiumService = inject(CesiumMapService);

    public createEditablePrism(id: string, prismOptions: PrismEditOptions, topHeight = 0, bottomHeight = 0, positions?: Cartesian3[]) {
        const editablePrism = new EditablePrism(id, this.cesiumService, prismOptions, topHeight, bottomHeight, positions);
        this.prisms.set(id, editablePrism);

        return editablePrism;
    }

    public get(id: string): EditablePrism | undefined {
        return this.prisms.get(id);
    }

    public clear() {
        this.prisms.forEach((prism) => prism.dispose());
        this.prisms.clear();
    }

    public hideAll() {
        this.prisms.forEach((prism) => prism.hide());
    }

    public showAll() {
        this.prisms.forEach((prism) => prism.show());
    }
}
